// extracted by mini-css-extract-plugin
module.exports = {"fundingMessage":"PaymentError-module__fundingMessage___1e-u2"};